// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {
	
});

export function buttonTopfoldPlaySteam_click(event) {
	wixWindow.trackEvent("CustomEvent", {
		"event": "SteamTopfoldButton",
		"eventCategory": "Click",
		"eventAction": "VisitSteam",
		"eventLabel": "ButtonTopfold"
	} );
}

export function buttonTopfoldPlayGog_click(event) {
	wixWindow.trackEvent("CustomEvent", {
			"event": "GogTopfoldButton",
			"eventCategory": "Click",
			"eventAction": "VisitGog",
			"eventLabel": "ButtonTopfold"
		} ); 
}

export function buttonBelowFold1Steam_click(event) {
	wixWindow.trackEvent("CustomEvent", {
			"event": "SteamBelowfoldButton",
			"eventCategory": "Click",
			"eventAction": "VisitSteam",
			"eventLabel": "ButtonBelowfold1"
		} ); 
}

export function buttonBelowFold1Gog_click(event) {
	wixWindow.trackEvent("CustomEvent", {
		"event": "GogBelowfoldButton",
		"eventCategory": "Click",
		"eventAction": "VisitGog",
		"eventLabel": "ButtonBelowfold1"
		}
	); 
}

export function buttonBelowFold2Steam_click(event) {
	wixWindow.trackEvent("CustomEvent", {
		"event": "SteamBelowfold2Button",
		"eventCategory": "Click",
		"eventAction": "VisitSteam",
		"eventLabel": "ButtonBelowfold2"
		} 
	); 
}

export function buttonBelowfold2Gog_click(event) {
	wixWindow.trackEvent("CustomEvent", {
		"event": "GogBelowfold2Button",
		"eventCategory": "Click",
		"eventAction": "VisitGog",
		"eventLabel": "ButtonBelowfold2"
		} 
	);  
}

export function buttonTopfoldArrowdown_click(event) {
	wixWindow.trackEvent("CustomEvent", {
		"event": "TopfoldArrowdown",
		"eventCategory": "Click",
		"eventAction": "TopfoldSeemore",
		"eventLabel": "ScrollDown"
		}
	);  
}

export function imageTopfoldPax10_click(event) {
	wixWindow.trackEvent("CustomEvent", {
		"event": "TopfoldPax10",
		"eventCategory": "ClickAttempt",
		"eventAction": "Pax10Image",
		"eventLabel": "ImageTopFold"
		}
	); 
}

export function imageTopfoldMomocon_click(event) {
	wixWindow.trackEvent("CustomEvent", {
		"event": "TopfoldMomocon",
		"eventCategory": "ClickAttempt",
		"eventAction": "MomoconImage",
		"eventLabel": "ImageTopFold"
		}
	);  
}